var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14a1 1 0 010 2H4a1 1 0 010-2h12zm0-5a1 1 0 010 2H4a1 1 0 010-2h12zm0-5a1 1 0 010 2H4a1 1 0 010-2h12z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAxNEMxNi41NTIgMTQgMTcgMTQuNDQ4IDE3IDE1QzE3IDE1LjU1MiAxNi41NTIgMTYgMTYgMTZINEMzLjQ0OCAxNiAzIDE1LjU1MiAzIDE1QzMgMTQuNDQ4IDMuNDQ4IDE0IDQgMTRIMTZaTTE2IDlDMTYuNTUyIDkgMTcgOS40NDggMTcgMTBDMTcgMTAuNTUyIDE2LjU1MiAxMSAxNiAxMUg0QzMuNDQ4IDExIDMgMTAuNTUyIDMgMTBDMyA5LjQ0OCAzLjQ0OCA5IDQgOUgxNlpNMTYgNEMxNi41NTIgNCAxNyA0LjQ0OCAxNyA1QzE3IDUuNTUyIDE2LjU1MiA2IDE2IDZINEMzLjQ0OCA2IDMgNS41NTIgMyA1QzMgNC40NDggMy40NDggNCA0IDRIMTZaIiBmaWxsPSIjMkMyRDJFIi8+Cjwvc3ZnPgo=";
export { SvgMenuOutline20 as ReactComponent };